import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Inject, Output, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ApiErrorFactory } from '../../../core/api-errors';
import { NonDefaultDomainUtility } from '../../../core/domain-utility';
import { SiteService } from '../../../core/site';
import { ErrorDialog } from '../../dialog';
import { DomainMessagesService } from '../domain-messages.service';
import { ProductAnalyticsService } from '@vendasta/product-analytics';
@Component({
  selector: 'app-add-domain-dialog',
  templateUrl: './add-domain.component.html',
  styleUrls: ['./add-domain.styles.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AddDomainDialogComponent {
  public disableInput = false;
  public disableButton = false;
  public domains: string[] = [];
  public siteId: string;
  @Output() domainListAdd: EventEmitter<any> = new EventEmitter<any>();
  private errorDialogRef: MatDialogRef<ErrorDialog>;

  constructor(
    public dialogRef: MatDialogRef<AddDomainDialogComponent>,
    public errorDialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private siteService: SiteService,
    private apiErrorFactory: ApiErrorFactory,
    private domainMessages: DomainMessagesService,
    public readonly analyticsService: ProductAnalyticsService,
  ) {
    this.siteId = data.siteId;
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }

  public clickSubmit(): void {
    const domains = this.domains.map(NonDefaultDomainUtility.normalizeDomain);
    if (domains.length > 0) {
      this.disableButton = true;
      this.disableInput = true;
      this.dialogRef.disableClose = true;

      for (const d of domains) {
        const message = this.domainMessages.getInvalidDomainMessage(d);
        if (message !== '') {
          this.displayErrorMessage(message);
          return;
        }
      }

      this.submitDomains(domains);
    }
  }

  protected submitDomains(domains: string[]): void {
    this.analyticsService.trackEvent('domain:add-domain', 'add-domain', 'submit');
    this.siteService.addDomainV3(this.siteId, domains).subscribe(
      () => {
        this.handleSuccess();
      },
      (err) => {
        this.handleError(err);
      },
    );
  }

  private handleSuccess(): void {
    this.domainListAdd.emit();
    this.dialogRef.close();
  }

  private handleError(errorResponse: HttpErrorResponse): void {
    const parsedError = this.apiErrorFactory.parseErrorResponse(errorResponse);
    this.displayErrorMessage(parsedError.getUserMessage());
  }

  private displayErrorMessage(message: string): void {
    this.errorDialogRef = this.errorDialog.open(ErrorDialog, {
      data: { errMsg: message },
    });

    this.disableButton = false;
    this.disableInput = false;
    this.dialogRef.disableClose = false;
  }
}
